'use client';
import React from 'react';

const Skeleton = ({ className = '', variant = 'rectangular', children, shimmer = true }) => {
  const baseClasses = shimmer 
    ? 'skeleton-shimmer' 
    : 'animate-pulse bg-gray-200';
  
  const variantClasses = {
    rectangular: 'rounded-md',
    circular: 'rounded-full',
    text: 'rounded',
  };

  return (
    <div data-component-id="src/components/ui/Skeleton.jsx:16:4" data-component-path="src/components/ui/Skeleton.jsx" data-component-line="16" data-component-end-line="18" data-component-file="Skeleton.jsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`${baseClasses} ${variantClasses[variant]} ${className}`}>
      {children}
    </div>
  );
};

export default Skeleton;
